import { ReactElement, useContext, useState } from "react"
import { AuthContext, Rotina } from "../../../context/Auth";
import { Agrup, ButtonRotina, Icon, Organize, Seta, SubAgrup } from "../style";
import cadastro from "../../../assets/img/Cadastro.svg";
import seta from "../../../assets/img/seta.svg";
import { ButtonMenu } from "../ButtonMenu";
import { useLocation } from "react-router-dom";

export const MenuCheckin = (): ReactElement | null => {

  const { usuarioRotinas } = useContext<any>(AuthContext);

  const [checkinClick, setClickCheckin] = useState<boolean>(false);

  const { pathname } = useLocation();

  const menus = usuarioRotinas.map((rotina: Rotina) => rotina.nomemenu);
  const rotinas = usuarioRotinas.map((rotina: Rotina) => rotina.nomerotina);

  return (
    <>
      {
        menus.some((menu: string) => menu == "Check-in") ?
          <ButtonRotina onClick={() => { setClickCheckin(!checkinClick); }}>
            <Organize active={pathname?.match('checkin')} >
              <Agrup>
                <Icon src={cadastro}></Icon>
                <p>Checkin</p>
              </Agrup>
              <Seta src={seta} active={checkinClick} />
            </Organize>
            {checkinClick ?
              <SubAgrup onClick={(event) => event?.stopPropagation()}>
                {
                  rotinas.some((rotina: string) => rotina == "Dashboard Check-in") ?
                    <ButtonMenu direcao="/dash/checkin/dashboard" nomeEstilo="subitem" titulo="Dashboard" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Lista de Membros") ?
                    <ButtonMenu direcao="/dash/checkin/membros" nomeEstilo="subitem" titulo="Membros" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Evento Check-in") ?
                    <ButtonMenu direcao="/dash/checkin/eventos" nomeEstilo="subitem" titulo="Controle de Eventos" />
                    : false
                }
              </SubAgrup>
              : false}

          </ButtonRotina>
          : false
      }
    </>
  )
}
